import * as Yup from "yup";
import { MESSAGE_ERREUR_MDP_OBLIGATOIRE, MESSAGE_ERREUR_MDP_FORMAT, MESSAGE_ERREUR_CONFIRMATION_MDP_OBLIGATOIRE, MESSAGE_ERREUR_MDP_NON_CORRESPONDANT } from "../../../data/message-erreurs-form";
import { passwordRegex } from "../../../utils/helpers";


export const PasswordSchema = Yup.object().shape({
  NewPassword: Yup.string()
    .required(MESSAGE_ERREUR_MDP_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_MDP_OBLIGATOIRE)
    .matches(
      passwordRegex,
      MESSAGE_ERREUR_MDP_FORMAT
    ),
  ConfirmationPassword: Yup.string()
    .required(MESSAGE_ERREUR_CONFIRMATION_MDP_OBLIGATOIRE)
    .oneOf([Yup.ref("NewPassword")], MESSAGE_ERREUR_MDP_NON_CORRESPONDANT)
    .typeError(MESSAGE_ERREUR_CONFIRMATION_MDP_OBLIGATOIRE)
    .matches(
      passwordRegex,
      MESSAGE_ERREUR_MDP_FORMAT
    )
});

export const ConfirmationPasswordSchema = Yup.object().concat(PasswordSchema).shape({
  OldPassword: Yup.string()
    .required(MESSAGE_ERREUR_MDP_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_MDP_OBLIGATOIRE)
})